// @ts-check
import required from 'utils/required';
import { SubdomainOrganization } from './types'; // eslint-disable-line no-unused-vars

import {
  REQUESTING_SIGN_OUT,
  RECEIVE_SIGN_OUT_SUCCESS,
  UPDATE_SUBDOMAIN_ORGANIZATION,
  CONNECTING_SESSION_CHANNEL,
  CONNECTED_SESSION_CHANNEL_SUCCESS,
} from 'agent_portal/actions/SessionActions';

/** @typedef {{
  signingOut: boolean,
  connectingChannel: boolean,
  sessionChannelId: string | void,
  socket: any | void,
  channel: any | void,
  subdomainOrganization: SubdomainOrganization | void,
  subdomainLogoUrl: string | void;
}} SessionStateShape */

const initialState = {
  signingOut: false,
  connectingChannel: false,
  sessionChannelId: undefined,
  socket: undefined,
  channel: undefined,
  subdomainOrganization: null,
  subdomainLogoUrl: null,
};

/**
 * @param {SessionStateShape} state
 * @param {GenericAction} action
 * @returns {SessionStateShape}
 */
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUESTING_SIGN_OUT:
      return {
        ...state,
        signingOut: true,
      };
    case RECEIVE_SIGN_OUT_SUCCESS:
      return {
        ...state,
        signingOut: false,
      };
    case UPDATE_SUBDOMAIN_ORGANIZATION:
      return {
        ...state,
        subdomainOrganization: action.payload.subdomainOrganization,
        subdomainLogoUrl: action.payload.subdomainLogoUrl,
      };
    case CONNECTING_SESSION_CHANNEL:
      const { sessionChannelId = required('sessionChannelId') } = action.payload;
      return {
        ...state,
        connectingChannel: true,
        sessionChannelId,
      };
    case CONNECTED_SESSION_CHANNEL_SUCCESS:
      const { socket = required('socket'), channel = required('channel') } = action.payload;
      return {
        ...state,
        connectingChannel: false,
        socket,
        channel,
      };
    default:
      return state;
  }
};

export default reducer;
